import dynamic from "next/dynamic"
import { PropsWithChildren } from "react"

export const NewHeader = dynamic<PropsWithChildren<{}>>(() =>
  import("./Header").then((mod) => mod.Header),
)
